import {createActions} from 'redux-actions';

export const {triggerSameValueSearch} = createActions({
    TRIGGER_SAME_VALUE_SEARCH: () => {},
});
